import { render } from "./BackgroundBlobs.vue?vue&type=template&id=65dcfa57&scoped=true"
import script from "./BackgroundBlobs.vue?vue&type=script&lang=ts"
export * from "./BackgroundBlobs.vue?vue&type=script&lang=ts"

import "./BackgroundBlobs.vue?vue&type=style&index=0&id=65dcfa57&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65dcfa57"

export default script